import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Button from '../../../components/button/Button';

import './blogSection.scss';

export default function BlogSection() {
  return (
    <section id="blog" className="did_you_know">
      <h2>
        Did you&nbsp;
        <span className="salmon">know?</span>
      </h2>
      <StaticImage src="../../../images/index/did_you_know_content.png" alt="" className="content" />
      <div className="content_mobile">
        <div className="yellow_bg">
          <StaticImage
            className="image"
            src="../../../images/index/did_you_know_reduce_stress.png"
            alt=""
          />
          <h6 className="bold">Reduce stress</h6>
          <p>When your body gets sufficient sleep, it is better able to cope with stress.</p>
        </div>
        <div className="twice">
          <StaticImage
            className="image"
            src="../../../images/index/did_you_know_mom_son_happy.png"
            alt=""
          />
          <StaticImage
            className="image"
            src="../../../images/index/did_you_know_man_sleeping.png"
            alt=""
          />
        </div>
        <div>
          <h6 className="bold">
            Improve your mood
          </h6>
          <p>Sleep facilitates the brain’s processing of emotional information.</p>
          <StaticImage
            className="image"
            src="../../../images/index/did_you_know_improve_your_mood.png"
            alt=""
          />
        </div>
        <div className="blue_bg white">
          <h6 className="bold">Mental disorders</h6>
          <p>
            Sleep disorders often go hand in hand with other mental health issues such as
            anxiety, stress and depression.
          </p>
        </div>
        <StaticImage className="image" src="../../../images/index/did_you_know_random_guy.png" alt="" />
        <div>
          <StaticImage
            className="image"
            src="../../../images/index/did_you_know_number.png"
            style={{ width: '60%', margin: 'auto' }}
            alt=""
          />
          <p>
            Sleep disorders are more widespread than you might think. According to a National
            Sleep Foundation survey,&nbsp;
            <span>43% of people aged 13–64</span>
            &nbsp;have reported lying awake at night due to stress at least once in the past
            month.
          </p>
        </div>
      </div>
      <Button
        text="Learn more"
        displayArrow
        dataAttr="CTA_clicked_did-you-know"
        className="blue"
        link="/blog/"
      />
    </section>
  );
}
